import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export interface ProfileSummary {
  id: string;
  name: string;
  email: string | null;
  location: string | null;
  summary: string | null;
  seniority: string | null;
}

export function useAllProfiles() {
  return useQuery({
    queryKey: ['profiles', 'all'],
    queryFn: () => apiFetch<ProfileSummary[]>('/profiles?limit=100')
  });
}
